import entete from "../assets/entete.jpg"

export default function Header({ handlePrint }) {
  return (
    <>
      <div className="w-full items-center justify-center">
        <img src={entete} />
        <br />
        <div className="flex justify-around">
          <p className="font-normal text-xs mb-3">
            Zone Industrielle ZONE D'ACTIVITE LLOT 70 SEC 161 Route de M'Slla,
            BORDJ BOU Arreridj
          </p>
          <p className="font-normal text-xs mb-3">
            Zone d'act. Bordj Bou Arreridj
          </p>
        </div>
        <div className="block sm:flex justify-around">
          <div className="flex flex-row ">
            <p className="font-bold uppercase text-md mb-3 mr-2">Tél.</p>
            <p className="font-normal uppercase text-md mb-3">035 87 63 19</p>
          </div>
          <div className="flex flex-row">
            <p className="font-bold uppercase text-md mb-3 mr-2">Fax.</p>
            <p className="font-normal uppercase text-md mb-3">035 87 61 61</p>
          </div>
          <div className="flex flex-row">
            <p className="font-bold uppercase text-md mb-3 mr-2">Email.</p>
            <p className="font-normal camelcase text-md mb-3">credit.consommation@condor.dz</p>
          </div>
        </div>
        <hr className="border-b-2 border-primary-color" />
      </div>
      <header className="flex flex-col items-center justify-between mb-5 xl:justify-between">

      </header>
    </>
  );
}
